import i18next from 'i18next';

import EntityFactory from '../factory/famly-app';
import PermissionEntity from './model';

export default EntityFactory.createEntity({
    domain: 'ENTITIES/PARENTAL_PERMISSION',
    entityName: i18next.t('entities.names.permission'),
    model: PermissionEntity,
    groupByKeys: ['institutionId'],
    apiDescription: {
        [EntityFactory.RequestType.FetchAll]: {
            url: 'v2/permissions/',
            requestPayload: payload => ({institutionId: payload.institutionId, includeDeleted: payload.includeDeleted}),
        },
        [EntityFactory.RequestType.Create]: {
            url: 'v2/permissions',
            requestPayload: ({title, body, recipients, institutionId, fileId}) => ({
                title,
                body,
                recipients,
                institutionId,
                fileId,
            }),
        },
        [EntityFactory.RequestType.Delete]: {
            url: payload => `v2/permissions/${payload.id}/delete`,
            requestMethod: EntityFactory.RequestMethod.POST,
        },
        /**
         * Note that this is not a real update function. Instead it is meant
         * to restore permissions that have been deleted. The reason it's added
         * under `Update` is due to the keys in `apiDescription` is limited to
         * the enum `RequestType`.
         */
        [EntityFactory.RequestType.Update]: {
            url: (payload: {id: string; institutionId: string}) => `v2/permissions/${payload.id}/restore`,
            requestMethod: EntityFactory.RequestMethod.POST,
        },
    },
});
